import * as React from 'react';
import { isNil } from 'lodash';

import MentionCardModalAsset from 'components/mention-card/mention-card-modal-asset/MentionCardModalAsset';
import ConsentPlaceholder from 'components/consent-placeholder/ConsentPlaceholder';

import { CHANNEL_TYPE_INSTAGRAM } from 'utils/channels';

import './mention-card-modal-asset-instagram.scss';

class MentionCardModalAssetInstagram extends MentionCardModalAsset {
  renderTrigger(): React.ReactNode {
    const { selectedItem, userChannelConsents } = this.props;

    if (!userChannelConsents[CHANNEL_TYPE_INSTAGRAM]) {
      return (
        <ConsentPlaceholder
          withLearnMore
          link={selectedItem.url}
          type="instagram"
        />
      );
    }

    if (isNil(selectedItem.assetUrl)) {
      return this.renderAssetImage('mention-card-modal-asset-instagram__image');
    }

    return this.renderModalTrigger(
      this.renderAssetImage('mention-card-modal-asset-instagram__image')
    );
  }

  render(): React.ReactNode {
    const { currentPosition } = this.props;

    return (
      <div
        key={`mention-card-modal-asset-instagram--position-${currentPosition}`}
        className="mention-card-modal-asset mention-card-modal-asset-instagram"
        data-qa="mention-card-modal-asset-instagram"
      >
        {this.renderTrigger()}
        {this.renderMentionCard('instagram')}
      </div>
    );
  }
}

export default MentionCardModalAssetInstagram;
